export default "__VITE_ASSET__B9OO7N1A__"